<template>
  <div>
    <div class="notFound">
      <div class="notFound__body">
        <p>認証エラーが発生しました</p>
        <Btn
          :label="'ログイン画面に戻る'"
          :color="'red'"
          class="withdraw"
          @click.native="$router.push({ name: 'Login' })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/parts/Btn'

export default {
  name: 'Unauthorized',

  components: {
    Btn
  },

  data () {
    return {
      //
    }
  },

  created () {
    this.$nextTick(() => {
      this.$store.commit('loadingAction', false)
    })
  }
}
</script>

<style lang="postcss" scoped>

  .notFound {
    position: relative;
    height: calc(100vh - 100px);
    &__body {
      padding: 75px 15px 30px;
      text-align: center;
    }

    & .withdraw {
      position: absolute;
      width: calc(100% - 30px);
      max-width: 600px;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/errors/401.vue